import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoBlack,
} from '../../../../St/Reports/UseStyle';
import { sto } from '../../../../Context/InshData';
import { insh as inshst } from "../../../../Context/InshSt";
import AccountSelect from '../../../../components/controls/accounts-select';
import { Button } from '@material-ui/core';
import { Save } from '@material-ui/icons';
import { useTranslation } from "react-i18next";
import AccountSearch from '../../../../components/controls/AccountsSearch';


export default function RestrictionForm(props) {

    const {
        onChangeSub,
        onChangeAutoSub,
        paramsAutoSub,
        AutoOptions,
        onSubmit,
        paramsSub,
        centers,
        prevent,
        openUpdate,
        IsOpen,
        handleInputSearchAccount,
        handleIconSearchAccount,
        searchAccountText,
        accountsOptions,
    } = props;
    const claslbl = useStylesLbl();
    const clasTF = useStylesTF();
    const clasui = useStylesUiElemment();
    const { t } = useTranslation(["forms", "translation"]);
    const handleFocus = (e) => e.target.select();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={4} md={4} sm={10} xs={12}>
                    <AccountSearch
                        accounts={accountsOptions}
                        account={paramsAutoSub.acc_no}
                        disabled={!prevent && !openUpdate ? true : false}
                        onSelect={(newValue) => {
                            onChangeAutoSub("acc_no", newValue);
                            document.getElementById("dept").focus()
                        }}
                        handleIconSearchAccount={handleIconSearchAccount}
                        handleInputSearchAccount={handleInputSearchAccount}
                        searchAccountText={searchAccountText}
                        name={t("account-code")}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="dept"
                        label={t("dept")}
                        type="number"
                        className={clasTF.rootCust}
                        onFocus={handleFocus}
                        disabled={!prevent && !openUpdate ? true : paramsSub?.credit > 0 ? true : false}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{
                            className: claslbl.clrBlackTxt,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    if (paramsSub.dept > 0) {
                                        if (IsOpen) {
                                            document.getElementById("notes").focus();
                                        } else {
                                            document.getElementById("ref_no").focus();
                                        }
                                    } else {
                                        document.getElementById("credit").focus();
                                    }
                                }
                            },
                        }}
                        name="dept"
                        value={paramsSub.dept}
                        onChange={onChangeSub("dept")} />
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="credit"
                        label={t("credit")}
                        type="number"
                        className={clasTF.rootCust}
                        disabled={!prevent && !openUpdate ? true : paramsSub?.dept > 0 ? true : false}
                        onFocus={handleFocus}
                        InputProps={{
                            className: claslbl.clrBlackTxt,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    if (IsOpen) {
                                        document.getElementById("notes").focus();
                                    } else {
                                        document.getElementById("ref_no").focus();
                                    }
                                    // document.getElementById("ref_no").focus();
                                }
                            },
                        }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="credit"
                        value={paramsSub.credit}
                        onChange={onChangeSub("credit")} />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={paramsAutoSub.center}
                        onChange={(event, newValue) => {
                            onChangeAutoSub("center", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={centers}
                        disabled={!prevent && !openUpdate ? true : false}
                        disableClearable={true}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="center"
                                {...params}
                                // label={t("cost-center")}
                                label={t("center")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />
                </Grid>
                {!IsOpen &&
                    (
                        <Grid item lg={2} md={2} sm={6} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                            <TextField fullWidth variant="outlined" size="small" id="ref_no"
                                label={t("ref-no")}
                                type="text"
                                className={clasTF.rootCust}
                                onFocus={handleFocus}
                                disabled={!prevent && !openUpdate ? true : false}
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                InputProps={{
                                    className: claslbl.clrBlackTxt,
                                    onKeyDown: (event) => {
                                        if (event.key === 'Enter') {
                                            document.getElementById("notes").focus();
                                        }
                                    },
                                }}
                                name="notes" value={paramsSub.ref_no}
                                onChange={onChangeSub("ref_no")} />
                        </Grid>
                    )}

                <Grid item lg={4} md={4} sm={6} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="notes"
                        label={t("note")}
                        type="text"
                        className={clasTF.rootCust}
                        disabled={!prevent && !openUpdate ? true : false}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        onFocus={handleFocus}
                        InputProps={{
                            className: claslbl.clrBlackTxt,
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onSubmit(event);
                                }
                            },
                        }}
                        name="notes" value={paramsSub.notes}
                        onChange={onChangeSub("notes")} />
                </Grid>
                <Grid container item lg={5} md={5} sm={12} xs={12} spacing={1} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>

                    <Grid item lg={4} md={4} sm={4} xs={4} style={{ paddingBottom: "0.5rem" }}>
                        <Autocomplete
                            classes={clasTF}
                            value={paramsAutoSub.omla}
                            onChange={(event, newValue) => {
                                onChangeAutoSub("omla", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={AutoOptions.omlats}
                            disableClearable={true}
                            disabled={!prevent && !openUpdate ? true : false}
                            style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            renderInput={(params) => (
                                <TextField
                                    id="center"
                                    {...params}
                                    label={t("currency")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={4} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="credit"
                            label={t("curr-exchange")}
                            type="number"
                            className={clasTF.rootCust}
                            disabled={!prevent && !openUpdate ? true : false}
                            onFocus={handleFocus}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="credit"
                            value={paramsSub?.omlaval}
                            onChange={onChangeSub("omlaval")} />
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={4} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="credit"
                            label={t("curr-local")}
                            type="number"
                            className={clasTF.rootCust}
                            disabled={true}
                            onFocus={handleFocus}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="credit"
                            value={((Number(paramsSub.dept) + Number(paramsSub.credit)) * Number(paramsSub.omlaval)).toFixed(2)} />
                    </Grid>
                </Grid>

                {!IsOpen &&
                    (
                        <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                            <TextField fullWidth variant="outlined" size="small" id="datef"
                                label={t("date")}
                                className={clasTF.rootCust}
                                InputProps={{ className: claslbl.clrBlackTxt }}
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                type="date" format="YYYY-MM-DD"
                                name="date" value={paramsSub.RestDate}
                                onChange={onChangeSub("RestDate")} />
                        </Grid>
                    )}

                <Grid item>
                    <Button
                        variant="contained"
                        startIcon={<Save />}
                        disabled={!prevent && !openUpdate ? true : false}
                        size="small"
                        style={
                            (inshst.safe.iconBtn,
                                { borderRadius: 0, backgroundColor: "#808080" })
                        }
                        className={[clasui.button]}
                        onClick={onSubmit}
                    >
                        {t("download")}
                    </Button>
                </Grid>


            </Grid>

        </React.Fragment>

    );

}